import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import useQaDocumentStatuses from '../../hooks/useQaDocumentStatuses'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'

const QaDocumentTypes = () => {
    useBrowserTabTitle('QA Document Types')

    const table = useRef(null)
    const urlGetData = '/v0/qa_document_types'
    const localStorageOrderKey = 'tblQaDocumentTypesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const [ tableData, setTableData ] = useState([])
    const [ archived, setArchived ] = useState([])

    const {
        linkSlot,
    } = useTableSlots()

    const { reloadQaDocumentStatuses } = useQaDocumentStatuses()
    
    const loadData = () => {
        fetch(urlGetData, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setTableData(json.results.filter(item => !item.is_archived))
                setArchived(json.results.filter(item => item.is_archived))
            })
            .catch(error => {
                console.log("QaDocumentTypes load error", error)
            })
    }

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        { data: 'code' },
        { data: 'label' },
        { data: 'template.filename' },
        { data: 'is_archived' },
    ]

    const tableHead = (
        <tr>
            <th>Code</th>
            <th>Type</th>
            <th>Template</th>
            <th>Actions</th>
        </tr>
    )
    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/qa_document_types/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/cadm/qa_document_types/${row.id}`),
        2: (data, type, row) => linkSlot(data, type, row, `/cadm/templates/${row.template.id}`),
        3: (data, type, row) => {
            return (
                <button type="button" className="btn btn-xs btn-light" onClick={() => archiveType(row)}>Archive</button>
            )
        },
    }

    const archiveType = (item) => {
        fetch('/v0/qa_document_types/'+item.id, {
            credentials: 'same-origin',
            method: 'POST',
            body: JSON.stringify({is_archived: true})
        }).then(function(response) {
            return response.json()
        }).then(function() {
            loadData()
            reloadQaDocumentStatuses()
        })
    }

    const restoreType = (item) => {
        fetch('/v0/qa_document_types/'+item.id, {
            credentials: 'same-origin',
            method: 'POST',
            body: JSON.stringify({is_archived: false})
        }).then(function(response) {
            return response.json()
        }).then(function() {
            loadData()
            reloadQaDocumentStatuses()
        })
    }

    const renderArchived = () => {
        const items = archived.length === 0 ?
                      
            (
                <li className="list-group-item">
                              Nothing Archived
                </li>
            ) :
                      
            archived.map(item => {
                return (
                    <li className="list-group-item" key={item.code}>
                        <button type="button" className="btn btn-xs btn-light" onClick={() => restoreType(item)}>Restore</button>
                                  &nbsp;
                        {item.code} - {item.name}
                    </li>
                )
            })
        
        return (
            <div>
                <h3>Archived QA Document Types</h3>
                <span className="help-block m-b-none m-t-none">
                    <small className="form-info-text" > Archived Types are not available for further selection.</small>
                </span>
                
                <ul className="list-group clear-list m-t">
                    {items}
                </ul>
            </div>
        )
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>QA Document Types</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/qa_document_types/new" className="btn btn-mr btn-primary" type="button">New QA Document Type</Link>
                                <Link to="/cadm/qms_document_types">QMS Document Types</Link>
                                <Link to="/cadm/qa_record_types">QA Record Types</Link>
                                <Link to="/cadm/templates">Manage Templates</Link>
                            </div>
                            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>QA document types</strong> are selected by the <strong>user</strong> when adding a new <strong>QA document</strong> in the <strong>quality</strong> menu area. <br/>
                                These are used to auto-generate <strong>references</strong>, in table views and searches, and allow the use of <strong>templates</strong> and <strong>SMART templates</strong>.<br/>
                                QA document types are mapped directly to their <strong>type-codes</strong> below. 
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                data={tableData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                            <br/>
                            {renderArchived()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
        
export default QaDocumentTypes
